export const SELECT_ADMIN = 'SURegistration/SELECT_ADMIN';
export const SET_UNKNOWN_PAA = 'SURegistration/SET_UNKNOWN_PAA';
export const RESET_STATE = 'SURegistration/RESET_STATE';
export const SET_PHONE_NUMBER = 'SURegistration/SET_PHONE_NUMBER';
export const SET_JOB_FUNCTIONS = 'SURegistration/SET_JOB_FUNCTIONS';
export const SUBMIT_TIN_REQUEST = 'SURegistration/SUBMIT_TIN_REQUEST';
export const SET_PERMISSIONS = 'SURegistration/SET_PERMISSIONS';
